import { ImmolationEffect } from './immolation_effect'

export default {
    events: {},
    effects: {
        ImmolationEffect
    },
    requirements: {}
}